exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-styles-components-___home-slider__homeSlider___12Noy,.src-components-styles-components-___home-slider__homeSliderRow___1vLs_,.src-components-styles-components-___home-slider__sliderContainer___24x9C{height:31.25vw}", ""]);

// exports
exports.locals = {
	"homeSlider": "src-components-styles-components-___home-slider__homeSlider___12Noy",
	"homeSliderRow": "src-components-styles-components-___home-slider__homeSliderRow___1vLs_",
	"sliderContainer": "src-components-styles-components-___home-slider__sliderContainer___24x9C"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/styles/components/home-slider.scss
 ** module id = 911
 ** module chunks = 0
 **/